import { createContext, PropsWithChildren, useContext, useState } from "react";

interface DrawerProviderProps extends PropsWithChildren {
    drawerOpen:boolean,
    setDrawerOpen:(v:boolean)=>void
}

interface DrawerContextReturn {
    drawerOpen:boolean,
    setDrawerOpen:(v:boolean)=>void,
    selectedGroup:string|undefined,
    setSelectedGroup:(v:string|undefined)=>void,
}

const McpDrawerContext = createContext<DrawerContextReturn>({
    drawerOpen:false,
    setDrawerOpen:(_)=>{},
    selectedGroup:undefined,
    setSelectedGroup:(_)=>{}
});

export const useMcpDrawerContext = ()=>{
    return useContext(McpDrawerContext);
}

export const McpDrawerProvider = ({
    drawerOpen,
    setDrawerOpen,
    children
}:DrawerProviderProps)=>{
    const [selectedGroup, setSelectedGroup] = useState<string|undefined>(undefined);

    return <McpDrawerContext.Provider value={{drawerOpen, setDrawerOpen, selectedGroup, setSelectedGroup}}>
        {children}
    </McpDrawerContext.Provider>
}